/**
 * z-index 层级配置
 * 
 * uniapp 在 H5 中各 API 的 z-index 值如下：
 * - actionsheet: 999
 * - modal: 999
 * - navigate: 998
 * - tabbar: 998
 * - toast: 999
 */

/** z-index 配置对象 */
export interface ZIndexConfig {
  toast: number;
  noNetwork: number;
  popup: number;
  mask: number;
  navbar: number;
  topTips: number;
  sticky: number;
  indexListSticky: number;
  popover: number;
}

const zIndex: ZIndexConfig = {
  toast: 10090,
  noNetwork: 10080,
  popup: 10075, // popup 包含 popup、actionsheet、keyboard、picker 的值
  mask: 10070,
  navbar: 980,
  topTips: 975,
  sticky: 970,
  indexListSticky: 965,
  popover: 960,
};

export default zIndex;
